import React from "react";
import Donatenow from "../imgs/DonateNow.png";

const Contatti = () => {
  return (
    <div className="flex flex-col items-center z-10 xs:text-base md:text-xl">
      <p className="text-red-600 font-extrabold xs:text-2x1 md:text-3xl">
        CONTATTI
      </p>
      <div className="flex flex-col items-center">
        <p className="mt-3">
          Per informazioni:{" "}
          <a href="mailto: info@milarte.it" className="text-red-600 underline">
            info@milarte.it
          </a>{" "}
          -{" "}
          <a
            href="mailto: milarte.mi@pec.it"
            className="text-red-600 underline"
          >
            milarte.mi@pec.it
          </a>
        </p>
        <p className="mt-3">
          <a href="https://www.giuseppedinardo.it/">Giuseppe Dinardo </a>: +39
          338 830 3778
        </p>
        <p className="mt-3">MilArte Via Giovanni Scheiwiller, 7 20139 Milano</p>
        <p className="mt-3">Per donazioni liberali</p>
        <img src={Donatenow} className="w-1/2" />
        <p className="mb-12">IBAN: IT 19 M 0760101600001067558849</p>
      </div>
    </div>
  );
};

export default Contatti;
